import { LoadError } from './promiseWithRetry.models';

const assetTimeoutDicctionary: Record<string, ReturnType<typeof setTimeout>> = {};

export const measureAsset = (id: string, initial = false) => {
  if (initial) performance.mark(id);
  const measure = performance.measure?.(id) ?? {};
  // return measure.duration;
  const now = new Date(measure.duration);
  return `${now.getSeconds().toString().padStart(2, '0')}.${now.getMilliseconds()}`;
};

export const executeWithTimeout = <T>(
  asyncFn: () => Promise<T>,
  timeout: number,
  id: string,
) => new Promise<T>((resolve, reject) => {
  assetTimeoutDicctionary[id] = setTimeout(
    () => reject(new LoadError(`${id} timed out after ${timeout}ms`, 'TIMEOUT')),
    timeout,
  );

  asyncFn()
    .then(resolve)
    .catch(reject)
    .finally(() => {
      clearTimeout(assetTimeoutDicctionary[id]);
    });
});
